
import React from "react";
import fields from "../../json/UserLisrFeilds.json";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormInputPassword from "Common/Custom/FormInputPassword";
import FormTextarea from "Common/Custom/FormTextarea";

const EditUserForm = ({
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  imagePreview,
}) => {
  const { formdata } = fields;
  return (
    <PageBody onSubmit={handleSubmit} headerchildren={
      <HeadingOne>Update User</HeadingOne>
    }>
      {formdata.map((field) => {

        if (field.type === "file") {
          return (
            <FormInputFile
            key={field.name}
            field={field}
            handleChange={handleFileChange}
            error={errors[field.name]}
            imagePreview={imagePreview}
          />
          );
        }

        if (field.type === "switch") {
          return (
            <Switch
              key={field.name}
              values={values[field.name]}
              handleChange={handleChange}
              field={field}
              ValueOne="1"
              ValueTwo="0"
              LabelOne="Active"
              LabelTwo="Inactive"
            />
          );
        }
        if (field.type === "password") {
                  return (
                    <FormInputPassword
                      key={field.name}
                      field={field}
                      value={values[field.name]}
                      handleChange={handleChange}
                      error={errors[field.name]}
                      type={field.type}
                    />
                  );
        }
        if (field.type === "textarea") {
          return (
            <FormTextarea
              key={field.name}
              field={field}
              value={values[field.name]}
              handleChange={handleChange}
              error={errors[field.name]}
            />
          );
        }
        // default text input
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      })}

      <FormSubmitButton
        label="Update"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditUserForm;
